import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceProductivity', ['loading']),
}

export const Methods = mapActions('deviceProductivity', ['getDeviceProductivity'])
